var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"title"},[_vm._t("default",function(){return [_c('h2',[_c('svg-icon',{attrs:{"icon-class":"per_title"}}),_c('span',[_vm._v("个人基本信息")])],1)]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }